import { UserException } from '@/domain/user/exception/UserException'

export class UserNotFoundException extends UserException {
}
